import DashboardService from "@/store/services/dashboard.service.js";

export default {
  namespaced: true,
  state: {
    gekkoNotificationTemplates: [],
    notificationNewCount: 0,
    notificationItems: [],
    inviteItems: [],
    dummy: false
  },
  getters: {
    getGekkoNotification: state => id => {
      return state.gekkoNotificationTemplates.find(item => item.id === id)
    },
    getNotificationNewCount: state => state.notificationNewCount,
    getInviteItems: state => state.inviteItems,
    getAllNotificationItems: state => state.notificationItems,
    getNotificationItems: state => status => state.notificationItems.filter(item => item.status === status),

  },
  mutations: {
    SET_NOTIFICATION (state, notification) {
      state.gekkoNotificationTemplates.push(notification)
    },
    SET_NOTIFICATION_NEW_COUNT (state, count) {
      state.notificationNewCount = count
    },
    NOTIFICATION_LIST_REFRESH (state) {
      state.dummy = !state.dummy
    },
    SET_NOTIFICATION_ITEMS (state, items) {
      state.notificationItems = items
    },
    SET_INVITE_ITEMS (state, items) {
      state.inviteItems = items
    }
  },
  actions: {
    acceptInvite ({ dispatch, commit }, payload) {
      return DashboardService.acceptInvitation(payload.invite_id).then(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Team invite'),
          text: this.getters.getRoot.$gettext('Successfully accepted the team invite from') + ' ' + payload.user_name,
          variant: 'success',
          duration: 4
        }, { root: true })
        dispatch('updateNotifications')
      })
    },
    rejectInvite ({ dispatch, commit }, payload) {
      return DashboardService.rejectInvitation(payload.invite_id).then(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Team invite'),
          text: this.getters.getRoot.$gettext('You rejected the team invite from') + ' ' + payload.user_name,
          variant: 'warning',
          duration: 4
        }, { root: true })
        dispatch('updateNotifications')
      })
    },
    getFreelancerInvite (context, invite_id) {
      return DashboardService.getFreelancerInvite(invite_id).then((response) => {
        return response
      })
    },
    acceptAccountantInvite ({ dispatch, commit }, payload) {
      return DashboardService.acceptAccountantInvitation(payload).then((response) => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Accountant request'),
          text: this.getters.getRoot.$gettext(payload.user_name + ' is now your accountant'),
          variant: 'success',
          duration: 4
        }, { root: true })
        dispatch('updateNotifications')
        return response;
      })
    },
    rejectAccountantInvite ({ dispatch, commit }, payload) {
      return DashboardService.rejectAccountantInvitation(payload.invite_id).then(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Accountant request'),
          text: this.getters.getRoot.$gettext('You rejected ' + payload.user_name + ' accountant request'),
          variant: 'warning',
          duration: 4
        }, { root: true })
        dispatch('updateNotifications')
      })
    },
    updateNotifications ({dispatch, commit}) {
      commit('timeline/TIMELINE_LIST_REFRESH', false, { root: true })
      dispatch('checkForNotifications')
      dispatch('checkForNotificationsCount')
    },
    loadAllNotifications ({ commit }) {
      const filters = {
        object_type: '',
        created_by_in: '',
        type: 'notification',
        company_profile: window.company_id
      }
      return DashboardService.activitiesTimeline(filters).then((response) => {
        const inviteItems = response.data.results.filter(notification => notification.object_type === 'team_invite' || notification.object_type === 'accountant_invite')
        const notificationItems = response.data.results.filter(notification => notification.object_type === 'gekko_notification')
        commit('SET_INVITE_ITEMS', inviteItems);
        commit('SET_NOTIFICATION_ITEMS', notificationItems);
        return response.data.next
      })
    },
    loadNotificationTemplate ({ commit }, notification_id) {
      return DashboardService.getGekkoNotification(notification_id).then((response) => {
        commit('SET_NOTIFICATION', response.data)
        return response.data
      })
    },
    toggleNotificationStatus ({ dispatch, commit }, notification_id) {
      return DashboardService.toggleSeenUnseen(notification_id).then(() => {
        dispatch('checkForNotificationsCount')
        commit('NOTIFICATION_LIST_REFRESH')
      })
    },
    checkForNotifications ({ dispatch, commit, getters }) {
      const prevNotifications = JSON.stringify(getters.getAllNotificationItems)
      dispatch('loadAllNotifications').then(() => {
        const refreshNotifications = JSON.stringify(getters.getAllNotificationItems)
        if (prevNotifications !== refreshNotifications) {
          commit('NOTIFICATION_LIST_REFRESH')
        }
      })
    },
    checkForNotificationsCount ({ commit, getters }) {
      const filters = {
        object_type: '',
        created_by_in: '',
        type: 'notification',
        status: 'unseen',
        company_profile: window.company_id
      }
      return DashboardService.getTimeentryCount(filters).then((response) => {
        const prevCount = JSON.stringify(getters.getNotificationNewCount)
        commit('SET_NOTIFICATION_NEW_COUNT', response.data)
        if (prevCount != response.data) {
          commit('NOTIFICATION_LIST_REFRESH')
        }
      })
    }
  }
}
